var module = angular.module('bbl.services.simpleshare');

module.factory('simplePeerAuthGuard', [
  'PeerDataChannel', '$http', 'PusherPubsub', '$q',
function(PeerDataChannel, $http, PusherPubsub, $q) {
  var pinlist$;

  var login = function authLogin(peersPinDb, pin) {
    if (peersPinDb && peersPinDb[pin]) {
      return Promise.reject('You\'ve been dismissed from the conversation!');
    }

    return (pinlist$ = pinlist$ || $http.get('/app/assets/invitae-pin-list/85df8f5b-8cda-41cc-a585-f023ce7fa0bd.json'))
      .then(function(response) {
        var user = response.data.find(function(d) { return d.pin === pin; });
        if (!user) {
          return Promise.reject('Invalid pin! Please make sure you entered the correct pin!');
        }
        return user;
      });
  };

  return function init(conn, room) {
    var peersPinDb = {'testpin': 'kicked'};
    var dbready$ = $q.defer();

    var channel = PeerDataChannel(conn, room+'-data');

    channel.sub(PeerDataChannel.types.CONNECTED, function(_, data) {
      channel.send({type: 'auth:kick', data: peersPinDb}, data.peer);
    });

    channel.sub(PeerDataChannel.types.ONMESSAGE, function(_, message) {
      if (message.type === 'auth:kick') {
        angular.merge(peersPinDb, message.data);
        // console.log(peersPinDb);
        dbready$.resolve(peersPinDb);
      }
    });


    PusherPubsub.sub(PusherPubsub.types.CALLER_BOOTED, function(data) {
      var kicked = {};
      kicked[data.callerPin] = 'kicked';
      angular.merge(peersPinDb, kicked);
      channel.send({type: 'auth:kick', data: kicked});
    });

    return {
      login: function(pin) {return dbready$.promise.then(function() {return login(peersPinDb, pin);});},
    };
  };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/simpleshare/auth.guard.js
 ** module id = 224
 ** module chunks = 0
 **/